module.exports = __webpack_public_path__ + "img/progress_035.9225a839.png";